import { Tooltip as MantineTooltip } from '@mantine/core';

import '@mantine/core/styles/Tooltip.css';
import { tooltip, labelContainer } from './Tooltip.css';
import { Box } from '@ui-lib';
import { unresponsiveProperties } from '../../css/atoms/atomicProperties';
import { ReactNode } from 'react';

type TooltipTone = 'neutral' | 'warning';

interface TooltipProps {
  label: ReactNode;
  open?: boolean;
  tone?: TooltipTone;
  position?: 'top' | 'right' | 'bottom' | 'left';
  children?: ReactNode;
}

export const Tooltip = ({ label, open, tone = 'neutral', position = 'top', children }: TooltipProps) => {
  const wrappedLabel = <Box className={labelContainer}>{label}</Box>;

  return (
    <MantineTooltip
      className={tooltip({
        tone,
      })}
      withArrow
      opened={open}
      label={wrappedLabel}
      position={position}
      arrowSize={10}
      zIndex={unresponsiveProperties.zIndex.tooltip}
    >
      {children}
    </MantineTooltip>
  );
};
